import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import { BackTextLink, TextButton } from "../../../components/UI/TextLink/TextLink";
import classes from './Friends.css';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import FriendBox from '../../../components/FriendBox/FriendBox';

class Friend extends React.Component{

    handleQuestion = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui'>
                    <div className={classes.Question}>
                    <Container>
                        <Row>
                            <Col>
                            <h3>What is it?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>Relation management automatically connects you and your friend based on the frequency you set.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <h3>How we become friends?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>After booking the initial conversation, your friend will be added here.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <h3>How it works?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>When a conversation is due, BookMeeY sends an email with your calendar link on your behalf to your friend. It only sent once, unless you change the frequency setting for this friend again, or there is a new conversation between you.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <h3>What is frequency?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>Frequency means how often you want to reconnect with your friend. The next reminder date is calculated based on frequency and the date of your last conversation. </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button variant="outline-info" onClick={onClose} block>I see</Button>
                            </Col>
                        </Row>
                    </Container>
                    </div>

                </div>
              );
            }
          });

    }

    render() { 

        let friendsContent;
        if (this.props.friends.length > 0) {
            friendsContent = this.props.friends.map((friend, index) => (
                <FriendBox key={index} relation={friend} isRegisteredFriend={true}/>
            ))
        }
        else {
            friendsContent = <div className={classes.NoFriendBox}>You currently don't have any registered friends</div>
        }


        let guestsContent;
        if (this.props.guests.length > 0) {
            guestsContent = this.props.guests.map((guest, index) => (
                <FriendBox key={index} relation={guest} isRegisteredFriend={false}/>
            ))
        }
        else {
            guestsContent = <div className={classes.NoFriendBox}>You currently don't have any guests</div>
        }


        return (

            <div className={classes.AppointmentManagement}>
                <Helmet>
                    <title>Relation Management | BookMeeY</title>
                    <meta name="description" content="Manage your BookMeeY appointment" />
                </Helmet>

                <Container>

                <Row>
                <Col lg={{span:8, offset:2}}>

                <div className={classes.AppointmentManagementContent}>

                <div className={classes.GoBack}>
                <Row>
                    <Col>
                    <BackTextLink />
                    </Col>
                </Row>
                </div>

                <Row>
                    <Col><h5> Relation Management </h5></Col>
                </Row>

                <Row>
                    <Col>
                    <div>
                        <p>
                        Relation manager helps you to maintain your relations with friends.
                        (<TextButton text="questions?" callback={this.handleQuestion} />)
                        </p>
                    </div>
                    </Col>
                </Row>

                <div className={classes.RelationArea}>
                
                <div className={classes.FriendArea}>
                <Row>
                    <Col>
                    <h5>Friends</h5>
                    <p>
                    Clicking on the name of your friends to book a conversation with them. 
                    Or enable relation manager on them, and they will receive periodic invitation for conversation.
                    </p>
                    <Accordion>
                    { friendsContent }
                    </Accordion>
                    </Col>
                </Row>
                </div>

                <div className={classes.GuestArea}>
                <Row>
                    <Col>
                    <h5>Unregistered Guests</h5>
                    <p>These are your guests that haven't registered yet.</p>
                    <Accordion>
                    { guestsContent }
                    </Accordion>
                    </Col>
                </Row>
                </div>


                </div>



                </div>
                </Col>
                </Row>

                </Container>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        friends: state.relation.friends,
        guests: state.relation.guests,
    };
};

export default connect( mapStateToProps ) (Friend);


// WEBPACK FOOTER //
// ./src/containers/RelationManagement/Friends/Friends.js